import gql from 'graphql-tag';

export const UPDATE_LOOK_TOOL_FILTER = gql`
  mutation updateLookToolFilter($filter: ToolFilterInput!, $orderBy: [String]) {
    updateLookToolFilter(filter: $filter, orderBy: $orderBy) @client
  }
`;
